import Vue from "vue";
import VueRouter from "vue-router";
import DashboardLayout from "../views/Layout/DashboardLayout.vue";
import ProfileLayout from "../views/Layout/ProfileLayout.vue";
import PageLayout from "../views/Layout/PageLayout";
import AuthLoginLayout from "../views/Layout/AuthLoginLayout";
import { store } from "../store";

// Dashboard pages
const Dashboard = () =>
    import("../views/Dashboard/Dashboard.vue");
import("../views/Dashboard/SmartHome.vue");


import( /* webpackChunkName: "pages" */ "@/views/Pages/Home.vue");
const Profile = () =>
    import( /* webpackChunkName: "pages" */ "@/views/Pages/ProfileOverview.vue");
const Intro = () =>
    import( /* webpackChunkName: "pages" */ "@/views/Pages/Intro.vue");
const ProfileOverview = () =>
    import(
        /* webpackChunkName: "pages" */
        "@/views/Pages/Profile/ProfileOverview.vue"
    );

const Login = () =>
    import(
        /* webpackChunkName: "pages" */
        "@/views/Pages/Authentication/Login/Login.vue"
    );
const Logout = () =>
    import(

        "@/views/Pages/Authentication/Logout/Logout.vue"
    );
const AdministrationOverview = () => import( /* webpackChunkName: "pages" */ "@/views/Administration/Overview.vue");
const AdministrationEventList = () => import( /* webpackChunkName: "pages" */ "@/views/Administration/Eventlist.vue");
const AdministrationClientDetails = () => import( /* webpackChunkName: "pages" */ "@/views/Administration/ClientDetails.vue");
const AdministrationEventDetails = () => import( /* webpackChunkName: "pages" */ "@/views/Administration/EventDetails.vue");
const AdministrationEventEdit = () => import( /* webpackChunkName: "pages" */ "@/views/Administration/EventEdit.vue");
const EventsAdmin = () =>
    import( /* webpackChunkName: "pages" */ "@/views/Events/Events.vue");
const Events = () =>
    import( /* webpackChunkName: "pages" */ "@/views/Pages/Events.vue");
const NotFound = () =>
    import( /* webpackChunkName: "pages" */ "@/views/Pages/404.vue");
const Home = () =>
    import( /* webpackChunkName: "pages" */ "@/views/Pages/Home.vue");
const EventDetailsAdmin = () =>
    import( /* webpackChunkName: "pages" */ "@/views/Events/EventDetails.vue");
const EventDetails = () =>
    import( /* webpackChunkName: "pages" */ "@/views/Pages/EventDetails.vue");
const EventEdit = () =>
    import( /* webpackChunkName: "pages" */ "@/views/Events/EventEdit.vue");
const EventOrder = () =>
    import( /* webpackChunkName: "pages" */ "@/views/Pages/EventOrder.vue");
const NewEvent = () =>
    import( /* webpackChunkName: "pages" */ "@/views/Events/NewEvent.vue");
const NewsAdmin = () =>
    import( /* webpackChunkName: "pages" */ "@/views/News/News.vue");
const News = () =>
    import( /* webpackChunkName: "pages" */ "@/views/Pages/News.vue");
const NewsDetails = () =>
    import( /* webpackChunkName: "pages" */ "@/views/Pages/NewsDetails.vue");
const Invoices = () =>
    import( /* webpackChunkName: "pages" */ "@/views/Pages/Invoices.vue");
const Tickets = () =>
    import( /* webpackChunkName: "pages" */ "@/views/Pages/Tickets.vue");
const Impressum = () =>
    import( /* webpackChunkName: "pages" */ "@/views/Pages/Impressum.vue");
const Datenschutz = () =>
    import( /* webpackChunkName: "pages" */ "@/views/Pages/Datenschutz.vue");
const Widerrufsbelehrung = () =>
    import( /* webpackChunkName: "pages" */ "@/views/Pages/Widerruf.vue");
const TicketDetails = () =>
    import( /* webpackChunkName: "pages" */ "@/views/Pages/TicketDetails.vue");
const NewsDetailsAdmin = () =>
    import( /* webpackChunkName: "pages" */ "@/views/News/NewsDetails.vue");
const NewNews = () =>
    import( /* webpackChunkName: "pages" */ "@/views/News/NewNews.vue");
const NewsEdit = () =>
    import( /* webpackChunkName: "pages" */ "@/views/News/NewsEdit.vue");

const Applinks = () =>
    import( /* webpackChunkName: "pages" */ "@/views/Pages/Applinks.vue");

Vue.use(VueRouter);


let profilePages = {
    path: "/",
    component: ProfileLayout,
    name: "Profile",
    children: [{
        path: "/admin/profile",
        name: "Profilübersicht",
        component: ProfileOverview,
        meta: {
            groupName: "Einstellungen",
        },

    },],
};

let pricingPage = {
    path: "/",
    component: PageLayout,
    // name: "Home Page",
    children: [{
        path: "/",
        name: "Home",
        component: Home,
    },
    {
        path: "/events",
        name: "Events",
        component: Events,
    },
    {
        path: "/events/:id",
        name: "Event Details",
        component: EventDetails,
    },
    {
        path: "/events/order/:id",
        name: "Event Order",
        component: EventOrder,
    },
    {
        path: "/news",
        name: "News",
        component: News,
    },
    {
        path: "/news/:id",
        name: "News Details",
        component: NewsDetails,
    },
    {
        path: "/profile",
        name: "Profil",
        component: Profile,
    },
    {
        path: "/sogehts",
        name: "Intro",
        component: Intro,
    },
    {
        path: "/invoices",
        name: "Invoices",
        component: Invoices,
    },
    {
        path: "/tickets",
        name: "Tickets",
        component: Tickets,
    },
    {
        path: "/tickets/:id",
        name: "Ticket Details",
        component: TicketDetails,
    },
    {
        path: "/impressum",
        name: "Impressum",
        component: Impressum,
    },
    {
        path: "/datenschutz",
        name: "Datenschutz",
        component: Datenschutz,
    },
    {
        path: "/applinks",
        name: "Applinks",
        component: Applinks,
    },
    {
        path: "/widerrufsbelehrung",
        name: "Widerrufsbelehrung",
        component: Widerrufsbelehrung,
    },
    ],
};


let loginPages = {
    path: "/",
    component: AuthLoginLayout,
    children: [{
        path: "/admin/login",
        name: "Login",
        component: Login,
    }, {
        path: "/admin/select-manager",
        name: "Manager Selection",
        component: () => import('@/views/Auth/ManagerSelection.vue'),
    }, {
        path: "/logout",
        name: "Logout",
        component: Logout,
    },],
};

let notFoundPage = {
    path: "*",
    component: PageLayout,
    children: [{
        path: "/",
        name: "404",
        component: NotFound,
    }],
};

let eventPages = {
    path: "/",
    component: DashboardLayout,
    children: [{
        path: "/admin/events",
        name: "Events Admin",
        component: EventsAdmin,
        meta: {
            groupName: "Events",
        },
    }, {
        path: "/admin/events/details/:id",
        name: "Event Details Admin",
        component: EventDetailsAdmin,
        meta: {
            groupName: "Events",
        },
    }, {
        path: "/admin/events/edit/:id",
        name: "Event bearbeiten",
        component: EventEdit,
        meta: {
            groupName: "Events",
        },
    }, {
        path: "/admin/events/new/",
        name: "Event anlegen",
        component: NewEvent,
        meta: {
            groupName: "Events",
        },
    }, {
        path: "/admin/pos/create-ticket",
        name: "POS-Ticket erstellen",
        component: () => import('@/views/Events/PosTicketCreate.vue'),
        meta: {
            groupName: "Events",
        },
    }, {
        path: "/admin/tickets/scan",
        name: "Ticket-Scanner",
        component: () => import('@/views/Scanner/ScannerInfo.vue'),
        meta: {
            groupName: "Events",
        },
    },],
};

let administationPages = {
    path: "/",
    component: DashboardLayout,
    name: "Administration",
    children: [{
        path: "/admin/administration",
        name: "Overview",
        component: AdministrationOverview,
        meta: {
            groupName: "Administration",
        },
    }, {
        path: "/admin/administration/client/:id",
        name: "Client Details",
        component: AdministrationClientDetails,
        meta: {
            groupName: "Administration",
        },
    }, {
        path: "/admin/administration/events/details/:id",
        name: "Event Details Administration",
        component: AdministrationEventDetails,
        meta: {
            groupName: "Administration",
        },
    }, {
        path: "/admin/administration/events/edit/:id",
        name: "Event Edit",
        component: AdministrationEventEdit,
        meta: {
            groupName: "Administration",
        },
    }, {
        path: "/admin/administration/invitations",
        name: "Manager Invitations",
        component: () => import('@/views/Administration/ManagerInvitations.vue'),
        meta: {
            groupName: "Administration",
        },
    }, {
        path: "/admin/eventlist",
        name: "Eventlist",
        component: AdministrationEventList,
        meta: {
            groupName: "Administration",
        },
    }],
};

let newsPages = {
    path: "/",
    component: DashboardLayout,
    children: [{
        path: "/admin/news",
        name: "News Admin",
        component: NewsAdmin,
        meta: {
            groupName: "News",
        },
    }, {
        path: "/admin/news/details/:id",
        name: "News Details Admin",
        component: NewsDetailsAdmin,
        meta: {
            groupName: "News",
        },
    },
    {
        path: "/admin/news/new/",
        name: "News anlegen",
        component: NewNews,
        meta: {
            groupName: "News",
        },
    },
    {
        path: "/admin/news/edit/:id",
        name: "News bearbeiten",
        component: NewsEdit,
        meta: {
            groupName: "News",
        },
    },
    ],
};


const routes = [{
    path: "/admin/",
    name: "Dashboard",
    redirect: "/admin/analytics",
    component: DashboardLayout,
    children: [{
        path: "/admin/analytics",
        name: "Analytics",
        component: Dashboard,
        meta: {
            groupName: "Dashboards",
        },
    },

    ],
},
    // Standalone route for invitation acceptance (must be before loginPages to avoid path conflict)
    {
        path: "/admin/invitations/accept/:token",
        name: "Accept Invitation",
        component: () => import('@/views/Administration/AcceptInvitation.vue'),
    },
    pricingPage,
    profilePages,
    loginPages,
    eventPages,
    administationPages,
    newsPages,
    notFoundPage,
];

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0, behavior: 'smooth', };
    },
});

// Router Guards für Berechtigungen
router.beforeEach((to, from, next) => {
    const isLoggedIn = store.getters.loggedIn;
    const isAdmin = store.getters.isAdmin;
    const hasMultipleManagers = store.getters.hasMultipleManagers;
    const currentForManagerId = store.getters.currentForManagerId;

    // Login-Seite und Einladungs-Akzeptierung sind immer erreichbar
    if (to.path === '/admin/login' || to.path.startsWith('/admin/invitations/accept/')) {
        next();
        return;
    }

    // Wenn nicht eingeloggt und versucht Admin-Bereich zu betreten
    if (to.path.startsWith('/admin') && !isLoggedIn) {
        next('/admin/login');
        return;
    }

    // Admin-Manager haben immer vollen Zugriff (OHNE Manager-Kontext-Prüfung)
    // Admin im eigenen Kontext: volle Rechte
    if (isLoggedIn && isAdmin && !store.getters.adminSimulated && store.getters.currentForManagerId === store.getters.ownManagerId) {
        next();
        return;
    }
    
    // Admin im fremden Kontext: Administration-Bereich ist nicht erlaubt
    if (isLoggedIn && isAdmin && !store.getters.adminSimulated && store.getters.currentForManagerId !== store.getters.ownManagerId) {
        if (to.path.includes('/admin/administration')) {
            next('/admin/analytics');
            return;
        }
        // Weiter mit normalen Berechtigungsprüfungen
    }

    // Für Nicht-Admins: Manager-Auswahl-Logik
    if (to.path === '/admin/select-manager') {
        if (!isLoggedIn) {
            next('/admin/login');
        } else if (!hasMultipleManagers || currentForManagerId) {
            next('/admin/analytics');
        } else {
            next();
        }
        return;
    }

    // Nach Login: Prüfen ob Manager-Auswahl nötig (nur für Nicht-Admins)
    // Einladungs-Akzeptierung muss ausgenommen werden!
    if (isLoggedIn && hasMultipleManagers && !currentForManagerId && to.path !== '/admin/select-manager' && !to.path.startsWith('/admin/invitations/accept/')) {
        next('/admin/select-manager');
        return;
    }

    // Event-spezifische Routen: Rollen-Prüfung (nur für Nicht-Admins)
    if (isLoggedIn && (to.path.includes('/admin/events') || to.path.includes('/admin/pos') || to.path.includes('/admin/tickets'))) {
        if (!currentForManagerId && hasMultipleManagers && !isAdmin) {
            next('/admin/select-manager');
            return;
        }

        // Spezifische Berechtigung prüfen (Admins sind ausgenommen)
        if (!isAdmin) {
            // Event Edit: Nur Owner oder Manager mit canManage (KEIN POS)
            if (to.path.includes('/admin/events/edit/')) {
                const isManager = store.getters.isManager;
                const isOwner = false; // Owner check would need event data, handled in component
                if (!isManager) {
                    next('/admin/analytics');
                    return;
                }
            }

            // POS access for POS users OR Managers OR Admins
            // Users with multiple roles (e.g. Checker + POS/Manager) can access POS
            if (to.path.includes('/admin/pos/create-ticket')) {
                const hasPosAccess = store.getters.isPosUser || store.getters.isManager || store.getters.isAdmin;
                if (!hasPosAccess) {
                    // Only block if user has NO POS/Manager/Admin role (even if they have Checker role)
                    const isOnlyChecker = store.getters.isChecker && !store.getters.isPosUser && !store.getters.isManager && !store.getters.isAdmin;
                    if (isOnlyChecker) {
                        next('/');
                        return;
                    }
                    next('/admin/analytics');
                    return;
                }
            }

            // Scanner access only for Checkers - redirect to info page
            if (to.path.includes('/admin/tickets/scan')) {
                if (!store.getters.isChecker) {
                    next('/admin/analytics');
                    return;
                }
                // Checker can access scanner info page
                next();
                return;
            }
            
            // Administration access only for real admins (not simulated)
            if (to.path.includes('/admin/administration') && store.getters.adminSimulated) {
                next('/admin/analytics');
                return;
            }
        }
    }

    next();
});

router.afterEach(() => {
    // Navigation completed
});

export default router;